/**
 * @module Sagas/User
 * @desc User
 */
import idx from 'idx';
import { END, eventChannel } from 'redux-saga';
import { all, call, fork, put, take, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { ActionTypes } from '../constants/index';

function upload(payload, onProgress) {
  const { file, data: graphqlData, cancelToken } = payload;
  const s3upload = idx(graphqlData, (_) => _.fastUpload.uploadUrl);
  const contentType = idx(graphqlData, (_) => _.fastUpload.contentType);

  if (s3upload && contentType) {
    const options = {
      cancelToken: cancelToken.token,
      onUploadProgress: onProgress,
      headers: {
        'Content-Type': contentType,
      },
    };
    return axios.put(s3upload, file, options);
  }
}

function createUploader(payload) {
  let emit;
  const chan = eventChannel((emitter) => {
    emit = emitter;
    return () => {}; // it's necessarily. event channel should
    // return unsubscribe function. In our case
    // it's empty function
  });

  const uploadPromise = upload(payload, (event) => {
    if (event.loaded === event.total) {
      emit(END);
    }

    emit({ id: payload.id, percentage: parseInt(((100 * event.loaded) / event.total).toFixed(0)) });
  });
  return [uploadPromise, chan];
}

function* watchOnProgress(chan) {
  while (true) {
    const data = yield take(chan);
    yield put({ type: ActionTypes.UPLOAD_FILE_UPDATE_PROGRESS, payload: data });
  }
}

/**
 *
 * Login
 */
export function* uploadRequest(action) {
  const [uploadPromise, chan] = createUploader(action.payload);
  yield fork(watchOnProgress, chan);

  try {
    const result = yield call(() => uploadPromise);
    const sentFileId = idx(action.payload, (_) => _.data.fastUpload.file.id);

    yield put({
      type: ActionTypes.UPLOAD_FILE_SUCCESS,
      payload: {
        id: action.payload.id,
        sentFileId: sentFileId || result.data.data.uploadFile.transferedFile.id,
      },
    });
  } catch (err) {
    if (axios.isCancel(err)) {
      yield put({ type: ActionTypes.UPLOAD_FILE_CANCEL, payload: { id: action.payload.id } });
    } else {
      yield put({
        type: ActionTypes.UPLOAD_FILE_FAILURE,
        payload: { id: action.payload.id, error: err },
      });
    }
  }
}

/**
 * User Sagas
 */
export default function* uploadSagas() {
  yield all([takeEvery(ActionTypes.UPLOAD_FILE_REQUEST, uploadRequest)]);
}
